import { render, staticRenderFns } from "./_platformWinLose.vue?vue&type=template&id=52c31a4c&lang=pug&"
import script from "./_platformWinLose.vue?vue&type=script&lang=js&"
export * from "./_platformWinLose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports